import { enabled } from './recordPrivacy'

export function canShareRecord(record, user) {
  return !!(record && enabled(record.public) && enabled(record.effective_public)
    && user && user.extra_data && enabled(user.extra_data.public))
}

export function sharedRecordId(value) {
  if (typeof value !== 'string' || !/^[1-9]\d*$/.test(value)) return null
  const id = Number(value)

  return Number.isSafeInteger(id) ? id : null
}

export async function copyPublicLink(text) {
  // Call writeText directly from the click event, before any network work (Safari).
  try {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      await navigator.clipboard.writeText(text)

      return
    }
  } catch (_) { /* Try the selection-based fallback below. */ }
  const focused = document.activeElement
  const field = document.createElement('textarea')
  field.value = text
  field.readOnly = true
  field.style.cssText = 'position:fixed;top:0;left:0;opacity:0;'
  document.body.appendChild(field)
  try {
    field.focus()
    field.select()
    field.setSelectionRange(0, text.length)
    if (!document.execCommand('copy')) throw new Error('Clipboard unavailable')
  } finally {
    field.remove()
    if (focused && typeof focused.focus === 'function') focused.focus()
  }
}
